import { render, staticRenderFns } from "./FormPasswordChange.vue?vue&type=template&id=337b1d82&scoped=true"
import script from "./FormPasswordChange.vue?vue&type=script&lang=js"
export * from "./FormPasswordChange.vue?vue&type=script&lang=js"
import style0 from "./FormPasswordChange.vue?vue&type=style&index=0&id=337b1d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b1d82",
  null
  
)

export default component.exports